import type { IconProps as FeatherProps } from 'react-feather';
import { Trash2 as TrashFeather } from 'react-feather';
import { cx } from '@trinity/chat-components/utils';
import styles from './style.module.css';

type Props = {
  trashProps?: FeatherProps;
  className?: string;
  onClick?: () => unknown;
  size?: number;
};

export default function Trash({ trashProps = {}, ...props }: Props) {
  const { className: trashClassName, ...otherTrashProps } = trashProps;

  return (
    <div
      className={cx(styles.root, props.className)}
      onClick={props.onClick}>
      <TrashFeather
        className={cx(styles.trash, trashClassName)}
        size={props.size}
        {...otherTrashProps} />
    </div>
  );
}

export { Trash };
